import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc, getDocs, deleteDoc, doc } from "firebase/firestore";

function ClassManager() {
  const [className, setClassName] = useState("");
  const [classes, setClasses] = useState([]);

  const fetchClasses = async () => {
    const snapshot = await getDocs(collection(db, "classes"));
    const classList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setClasses(classList);
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (className.trim() === "") return;

    await addDoc(collection(db, "classes"), { name: className });
    setClassName("");
    fetchClasses();
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "classes", id));
    fetchClasses();
  };

  const handleBack = () => {
    window.history.back(); // Tarayıcıda bir önceki sayfaya döner
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2 style={{ marginBottom: "20px" }}>📘 Sınıf Ekle</h2>

      <form onSubmit={handleSubmit} style={{ marginBottom: "30px" }}>
        <input
          type="text"
          placeholder="Sınıf adı"
          value={className}
          onChange={(e) => setClassName(e.target.value)}
          style={{
            padding: "10px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginRight: "10px",
            width: "250px"
          }}
        />
        <button
          type="submit"
          style={{
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          Ekle
        </button>
      </form>

      <ul style={{ listStyle: "none", padding: 0 }}>
        {classes.map((cls) => (
          <li
            key={cls.id}
            style={{
              marginBottom: "15px",
              backgroundColor: "#f0f0f0",
              padding: "10px 20px",
              borderRadius: "8px",
              display: "inline-block",
              minWidth: "300px"
            }}
          >
            <strong>{cls.name}</strong>
            <div style={{ marginTop: "10px" }}>
              <button
                onClick={() => handleDelete(cls.id)}
                style={{
                  marginRight: "10px",
                  padding: "6px 14px",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                Sil
              </button>
              <button
                onClick={handleBack}
                style={{
                  padding: "6px 14px",
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer"
                }}
              >
                Geri
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ClassManager;
